import { css } from 'styled-components';

export const themeTokens = {
  checkoutTemplate: {
    wrapper: css`
      background: ${({ theme }) => theme.colors.palette.marble};
    `,
  },
  joinVipAnnual: {
    shared: {
      styledText: css`
        color: ${(props) => props.theme.colors.palette.lavender700};

        ${({ allCaps, theme }) =>
          allCaps
            ? theme.typography.values.subHeading8Uppercase
            : theme.typography.values.subHeading8}

        ${({ allCaps }) =>
          allCaps &&
          css`
            line-height: 1.5;
          `}
      `,
      learnMoreLink: css`
        & > span {
          color: ${(props) => props.theme.colors.palette.lavender700};

          &:hover,
          &:focus,
          &:active {
            color: ${(props) => props.theme.colors.palette.lavender700};
            text-decoration: none;
          }
        }
      `,
    },
  },
  basketItemPrice: {
    basketPrice: css`
      ${({ theme }) => theme.typography.values.subHeading8Uppercase}

      line-height: 1.5;

      color: ${(props) => props.isClearanceItem && props.theme.colors.error};

      color: ${(props) =>
        !props.isClearanceItem && props.special
          ? props.theme.colors.palette.gunmetal
          : 'inherit'};

      ${({ shoppingBagFlagStatus, theme, special, old }) =>
        !shoppingBagFlagStatus?.isControl &&
        theme.context.cartDrawer &&
        css`
          ${special &&
          `
          font-weight: 600;
          color: ${theme.colors.palette.black};
        `}

          ${old && `color: ${theme.colors.palette.gunmetal600};`}
        `}
    `,
    priceLabel: css`
      ${({ theme }) => theme.typography.values.subHeading8Uppercase}

      line-height: 1.5;
    `,
  },
  basketItemDetails: {
    basketPricePromo: css`
      color: ${(props) =>
        props.isClearanceItem
          ? props.theme.colors.error
          : props.theme.colors.palette.lavender700};

      ${({ theme }) => theme.typography.values.subHeading8Uppercase}

      line-height: 1.3;
    `,
  },
  basketItem: {
    productName: css`
      ${({ theme }) => theme.typography.values.subHeading8Uppercase}

      line-height: 1.3;
    `,
  },
  basicModal: {
    dialogStyle: css`
      background-color: ${({ theme }) => theme.colors.palette.white};
    `,
  },
  productDetailName: {
    productName: css`
      ${({ theme }) => theme.typography.values.heading6Uppercase}

      line-height: 1.2;
    `,
  },
  productDetailHeader: {
    promoTextWrapper: css`
      color: ${({ theme }) => theme.colors.memberOfferText};
      ${({ theme }) => theme.typography.values.subHeading8Uppercase};
      font-weight: 400;
      line-height: 1.5;
    `,
  },
  productDetailSizeSelector: {
    sizeCategoryLabel: css`
      color: ${({ theme }) => theme.colors.palette.gunmetal600};

      ${({ theme }) =>
        theme.typography.variants.checkout.itemInformation.textStyle}
    `,
  },
  colorSwatch: {
    colorTitle: css`
      color: ${({ theme }) => theme.colors.palette.gunmetal600};
    `,
  },
  quickViewModal: {
    updateButton: css`
      border-radius: 0px;
      transition: background-color 300ms linear, border-color 300ms linear;

      & > span {
        font-size: 14px;
      }
    `,
    styledLink: css`
      ${({ theme }) => theme.typography.values.subHeading6smallUppercase}
      line-height: 1.3;
      color: ${({ theme }) => theme.colors.palette.lavender600};
      border: 1px solid ${({ theme }) => theme.colors.palette.lavender600};
      background-color: transparent;
      transition: background-color 300ms linear, border-color 300ms linear;

      &:hover {
        background-color: ${({ theme }) => theme.colors.palette.lavender100};
        border-color: ${({ theme }) => theme.colors.palette.lavender700};
      }
    `,
  },
};
